/* eslint-disable react/prop-types */
import React from 'react';
import moment from 'moment';
import ToolIcon from '../../../../../../assets/icons/tool.svg';
import CarIcon from '../../../../../../assets/icons/car.svg';
import { getLeastProgressedTrip } from '../../../../common/helpers';

const getDriverFullName = (trip) => {
  if (!trip?.driver) return '';
  const { driver } = trip;
  return `${driver.firstName || ''} ${driver.lastName || ''}`;
};

const getTimeSinceAllocationChange = (trip) => {
  if (!trip?.updatedAt) return '';
  const timeAllocationWasMade = trip.updatedAt;
  return moment(timeAllocationWasMade).fromNow();
};

const shouldDisplayDriversName = (columnName) => columnName !== 'unallocated';

const DriversAllocationCard = ({ booking, laneId }) => {
  const { customer, garage, collectionDateTimeLocal, trips } = booking || {};
  const columnName = laneId;
  const relevantTrip = getLeastProgressedTrip(trips);
  return (
    <a className="allocation-card" target="_blank" href={`/bookings/${booking.bookingId}`} rel="noreferrer">
      <div className="allocation-card-title">
        {' '}
        {customer?.firstName} {customer?.lastName}{' '}
      </div>
      <div className="allocation-card-garage-name">
        <ToolIcon style={{ width: '1em', height: '1em', verticalAlign: 'middle', marginRight: '4px', overflow: 'visible' }} /> {garage?.businessName}
      </div>
      {shouldDisplayDriversName(columnName) && (
        <div className={`allocation-card-driver-${columnName}`}>
          <CarIcon style={{ width: '1em', height: '1em', verticalAlign: 'middle', marginRight: '4px', overflow: 'visible' }} /> {getDriverFullName(relevantTrip)}
          <br />
          {columnName === 'pending' ? `Sent ${getTimeSinceAllocationChange(relevantTrip)}` : ''}
          {columnName === 'declined' ? `Sent ${getTimeSinceAllocationChange(relevantTrip)}` : ''}
        </div>
      )}
      <div className="allocation-card-footer">
        <span> {moment(collectionDateTimeLocal).format('DD MMM YYYY')}</span>
        {' at '}
        <span> {moment(collectionDateTimeLocal).format('h:mm a')}</span>
      </div>
    </a>
  );
};

export default DriversAllocationCard;
